import React, { useState } from 'react';
import { getLabels } from '../fieldLabels';

const API_BASE = "https://adria.terrier-ule.ts.net";

export default function BleRegister() {
  const params   = new URLSearchParams(window.location.search);
  const doorId   = params.get('door')     || '';
  const tenantId = params.get('tenant')   || '';
  const template = params.get('template') || 'residential';
  const L        = getLabels(template);

  const [step,   setStep]   = useState('form');
  const [name,   setName]   = useState('');
  const [phone,  setPhone]  = useState('');
  const [roomNo, setRoomNo] = useState('');
  const [status, setStatus] = useState('');
  const [modal,  setModal]  = useState('');

  if (!doorId || !tenantId) {
    return (
      <div style={wrap}>
        <div style={card}>
          <div style={{ fontSize: '50px', marginBottom: '12px' }}>⚠️</div>
          <h2 style={{ color: '#ef4444', margin: '0 0 8px', fontSize: '17px' }}>잘못된 링크</h2>
          <p style={{ color: '#6b7280', fontSize: '13px', margin: 0 }}>
            관리자에게 올바른 등록 링크를 받아주세요.
          </p>
        </div>
      </div>
    );
  }

const handleRegister = async () => {
    // 1. 필수 입력값 확인
    if (!name || !phone || !roomNo) {
      setStatus(L.required_msg); return;
    }

    // 2. 브라우저 지원 확인
    if (!navigator.bluetooth) {
      setStatus('이 브라우저는 Bluetooth를 지원하지 않습니다.'); return;
    }

    setStep('waiting');
    setStatus('등록 정보 확인 중...');

    try {
      // 3. 서버에 등록 세션 생성
      const res = await fetch(`${API_BASE}/api/ble/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-tenant-id': tenantId, 'x-door-id': doorId },
        body: JSON.stringify({ user_name: name, phone, room_no: roomNo }),
      });

      if (!res.ok) {
        setStep('form');
        setStatus('');
        setModal('입주자 정보가 일치하지 않습니다.\n이름, 전화번호, 호수를 다시 한번 확인 후 입력해 주세요.');
        return;
      }
      
      const regData = await res.json();
      const deviceId = regData.device_id; 

      // 4. 블루투스 장치 찾기 및 연결 (본딩 유도)
      setStatus(`🔵 도어락(${doorId})을 검색 중...`);
      const device = await navigator.bluetooth.requestDevice({
        filters: [{ name: 'DOOR' }],
        optionalServices: ['generic_access'],
      });

      setStatus('🔗 도어락과 연결 중...');
      const server = await device.gatt.connect();
      
      // 본딩 데이터 생성 대기 후 연결 해제
      await new Promise(r => setTimeout(r, 2000)); 
      try { await server.disconnect(); } catch (_) {}

      // 5. 서버 상태 폴링 (최종 확인)
      setStatus('📝 등록 상태를 확인하고 있습니다...');
      
      let isReady = false;
      for (let i = 0; i < 15; i++) {
        const statusRes = await fetch(`${API_BASE}/api/ble/devices/${deviceId}/status`, {
          headers: { 'x-tenant-id': tenantId }
        });
        const statusData = await statusRes.json();

        if (statusData.registered === true) {
          isReady = true;
          break;
        }
        await new Promise(r => setTimeout(r, 2000)); 
      }

      if (isReady) {
        setStep('done'); // 등록 완료 화면 표시
      } else {
        setStatus('❌ 등록 확인 시간이 초과되었습니다.');
        setStep('form');
      }

    } catch (e) {
      console.error(e);
      if (e.name === 'NotFoundError') {
        setStatus('❌ 도어락을 찾지 못했습니다.');
      } else {
        setStatus(`❌ 오류: ${e.message}`);
      }
      setStep('form');
    }
  };
  // ── 완료 화면 ─────────────────────────────────────────────
  if (step === 'done') {
    return (
      <div style={wrap}>
        <div style={card}>
          <div style={{ fontSize: '60px', marginBottom: '16px' }}>✅</div>
          <h2 style={{ color: '#10b981', margin: '0 0 8px' }}>등록 완료!</h2>
          <p style={{ color: '#6b7280', fontSize: '14px', margin: '0 0 8px', lineHeight: '1.7' }}>
            잠시 후 도어락에 자동으로 반영됩니다.<br />
            블루투스를 켠 상태로 도어락 앞에 서면<br />문이 자동으로 열립니다.
          </p>
          <div style={{ fontSize: '12px', color: '#9ca3af', backgroundColor: '#f9fafb',
                        padding: '8px 12px', borderRadius: '8px' }}>
            {doorId} · {name} · {roomNo}호
          </div>
        </div>
      </div>
    );
  }

  // ── 대기 화면 (NFC와 동일 구조) ──────────────────────────
  if (step === 'waiting') {
    return (
      <div style={wrap}>
        <div style={card}>
          <div style={{ fontSize: '60px', marginBottom: '16px' }}>🔵</div>
          <h2 style={{ color: '#4f46e5', margin: '0 0 12px', fontSize: '17px' }}>블루투스 연결 중</h2>
          <p style={{ color: '#374151', fontSize: '14px', margin: '0 0 20px',
                      whiteSpace: 'pre-line', lineHeight: '1.8' }}>
            {status}
          </p>
          <div style={{ fontSize: '12px', color: '#9ca3af', backgroundColor: '#f9fafb',
                        padding: '8px 12px', borderRadius: '8px', marginBottom: '16px' }}>
            {doorId} · {name} · {roomNo}호
          </div>
          <button onClick={() => { setStep('form'); setStatus(''); }}
            style={{ padding: '10px 24px', backgroundColor: '#e5e7eb', color: '#4b5563',
                     border: 'none', borderRadius: '10px', fontSize: '13px', cursor: 'pointer' }}>
            취소
          </button>
        </div>
      </div>
    );
  }

  // ── 등록 폼 ───────────────────────────────────────────────
  return (
    <div style={wrap}>
      {modal && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)',
                      zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center',
                      padding: '20px' }}>
          <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '24px 20px',
                        maxWidth: '320px', width: '100%', textAlign: 'center',
                        boxShadow: '0 8px 30px rgba(0,0,0,0.15)' }}>
            <div style={{ fontSize: '36px', marginBottom: '12px' }}>⚠️</div>
            <p style={{ fontSize: '14px', color: '#374151', lineHeight: '1.7',
                        margin: '0 0 20px', whiteSpace: 'pre-line' }}>
              {modal}
            </p>
            <button onClick={() => setModal('')}
              style={{ padding: '10px 32px', backgroundColor: '#4f46e5', color: '#fff',
                       border: 'none', borderRadius: '10px', fontWeight: 'bold',
                       fontSize: '14px', cursor: 'pointer' }}>
              확인
            </button>
          </div>
        </div>
      )}
      <div style={card}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',
                      gap: '10px', marginBottom: '20px' }}>
          <span style={{ fontSize: '32px', lineHeight: 1 }}>🔐</span>
          <h2 style={{ margin: 0, color: '#1f2937', fontSize: '18px' }}>블루투스 출입 등록</h2>
        </div>
        <div style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0',
                      borderRadius: '12px', padding: '14px', marginBottom: '16px', textAlign: 'left' }}>
          <div style={{ margin: '0 0 12px', fontSize: '13px', color: '#374151', lineHeight: '1.6' }}>
            <div style={{ fontWeight: 'bold', color: '#065f46' }}>📍 등록 방법</div>
            <div>1. 출입문 근처로 이동해 주세요</div>
            <div>2. 휴대폰 블루투스를 켜주세요<br />
              <span style={{ fontSize: '12px', color: '#6b7280', paddingLeft: '14px' }}>(설정 → 블루투스 → 켜기)</span>
            </div>
            <div>3. 아래 정보를 입력 후 등록 버튼을 눌러주세요</div>
            <div>4. 블루투스 목록에서 <b>DOOR</b>를 찾아 선택해주세요</div>
            <div>5. 잠깐 기다리시면 자동으로 등록됩니다 😊</div>
          </div>
          <div style={{ margin: '0 -14px -14px', padding: '12px 14px 14px',
                        backgroundColor: '#fefce8', borderTop: '1px solid #fde047',
                        borderRadius: '0 0 12px 12px' }}>
            <p style={{ fontSize: '12px', fontWeight: 'bold', color: '#854d0e', margin: '0 0 4px' }}>
              ⚠️ 지원 브라우저에서만 동작합니다
            </p>
            <div style={{ fontSize: '12px', color: '#374151', margin: '0 0 8px', lineHeight: '1.7' }}>
              <div style={{ marginBottom: '8px' }}>
                🤖 <b>안드로이드</b> — 크롬(Chrome) 브라우저&nbsp;
                <a href="https://play.google.com/store/apps/details?id=com.android.chrome"
                  target="_blank" rel="noreferrer"
                  style={{ fontSize: '11px', padding: '2px 7px', backgroundColor: '#10b981', color: '#fff',
                           borderRadius: '5px', textDecoration: 'none', fontWeight: 'bold' }}>
                  설치
                </a>
              </div>
              <div>
                🍎 <b>아이폰</b> — 블루파이(Bluefy) 브라우저&nbsp;
                <a href="https://apps.apple.com/app/bluefy-web-ble-browser/id1492822055"
                  target="_blank" rel="noreferrer"
                  style={{ fontSize: '11px', padding: '2px 7px', backgroundColor: '#10b981', color: '#fff',
                           borderRadius: '5px', textDecoration: 'none', fontWeight: 'bold' }}>
                  설치
                </a>
              </div>
            </div>
            <span style={{ fontSize: '11px', color: '#1d4ed8', fontWeight: 'bold' }}>
              링크 복사 버튼을 누른 후 지원 브라우저 주소창에 붙여넣으시고 등록해주세요~&nbsp;<CopyLinkButton />
            </span>
          </div>
        </div>

        <input placeholder={L.user_name_ph} value={name}
          onChange={e => setName(e.target.value)} style={inputStyle} />
        <input placeholder={L.phone_ph} value={phone}
          onChange={e => setPhone(e.target.value)} style={inputStyle} type="tel" />
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px' }}>
          <input placeholder={L.room_no_ph} value={roomNo} type="text"
            onChange={e => setRoomNo(e.target.value.replace(/[^0-9]/g, ''))}
            style={{ ...inputStyle, marginBottom: 0, flex: 1 }} />
          <span style={{ fontSize: '15px', fontWeight: 'bold', color: '#374151' }}>호</span>
        </div>

        {status && (
          <p style={{ fontSize: '13px', color: '#ef4444',
                      margin: '0 0 12px', whiteSpace: 'pre-line', textAlign: 'center' }}>
            {status}
          </p>
        )}

        <button onClick={handleRegister}
          style={{ width: '100%', padding: '14px', backgroundColor: '#4f46e5',
                   color: '#fff', border: 'none', borderRadius: '12px',
                   fontWeight: 'bold', fontSize: '15px', cursor: 'pointer' }}>
          📡 블루투스 등록하기
        </button>

      </div>
    </div>
  );
}

function CopyLinkButton() {
  const [copied, setCopied] = React.useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {
      const el = document.createElement('textarea');
      el.value = window.location.href;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  return (
    <button onClick={handleCopy} style={{
      flexShrink: 0, padding: '2px 7px',
      backgroundColor: copied ? '#059669' : '#10b981',
      color: '#fff', border: 'none', borderRadius: '5px',
      fontWeight: 'bold', fontSize: '11px', cursor: 'pointer', whiteSpace: 'nowrap',
    }}>
      {copied ? '✅ 복사됨!' : '🔗 링크 복사'}
    </button>
  );
}

const wrap      = { display: 'flex', alignItems: 'center', justifyContent: 'center',
                    minHeight: '100vh', backgroundColor: '#f3f4f6', padding: '20px' };
const card      = { backgroundColor: '#fff', padding: '36px 28px', borderRadius: '20px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '100%',
                    maxWidth: '360px', textAlign: 'center' };
const inputStyle = { width: '100%', padding: '12px', borderRadius: '10px',
                     border: '1px solid #d1d5db', fontSize: '14px',
                     boxSizing: 'border-box', marginBottom: '10px' };
